import { gql } from "graphql-request";

export function subscriptionCheckQuery(firebaseId: string) {
  return gql`
        query {
            user(firebaseId: "${firebaseId}") {
                id
                firebaseId
                subscriptionHasExpired
            }
        }
    `;
}
